import React, { useCallback, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { action, get, set } from 'mobx';
import classNames from 'classnames';
import measureScrollbar from 'choerodon-ui/lib/_util/measureScrollbar';
import { pxToRem } from 'choerodon-ui/lib/_util/UnitConvertor';
import TableContext from './TableContext';
import { ColumnLock, DragColumnAlign } from './enum';
import TableFooterCell from './TableFooterCell';
import { isStickySupport } from './utils';
import ResizeObservedRow from './ResizeObservedRow';
import { CUSTOMIZED_KEY } from './TableStore';
const TableFooter = observer(function TableFooter(props) {
    const { lock, columnGroups } = props;
    const { prefixCls, rowHeight, tableStore } = useContext(TableContext);
    const { overflowX } = tableStore;
    const handleResize = useCallback(action((index, height) => {
        set(tableStore.lockColumnsFootRowsHeight, index, height);
    }), [tableStore]);
    const getTds = () => {
        const { customizable, rowDraggable, dragColumnAlign } = tableStore;
        const hasPlaceholder = tableStore.overflowY && lock !== ColumnLock.left;
        const right = hasPlaceholder ? measureScrollbar() : 0;
        const tds = columnGroups.leafs.map((columnGroup, index, cols) => {
            const { key } = columnGroup;
            if (key !== CUSTOMIZED_KEY) {
                const colSpan = customizable && lock !== ColumnLock.left && (!rowDraggable || dragColumnAlign !== DragColumnAlign.right) && index === cols.length - 2 ? 2 : 1;
                const cellProps = {};
                if (colSpan > 1) {
                    cellProps.colSpan = colSpan;
                }
                return (React.createElement(TableFooterCell, Object.assign({ key: key, columnGroup: columnGroup, right: right }, cellProps)));
            }
            return undefined;
        });
        if (hasPlaceholder) {
            const placeHolderProps = {
                key: 'fixed-column',
            };
            const classList = [`${prefixCls}-cell`];
            if (isStickySupport() && overflowX) {
                placeHolderProps.style = { right: 0 };
                classList.push(`${prefixCls}-cell-fix-right`);
            }
            placeHolderProps.className = classList.join(' ');
            tds.push(React.createElement("th", Object.assign({}, placeHolderProps), "\u00A0"));
        }
        return tds;
    };
    const style = !isStickySupport() && lock && (rowHeight === 'auto' || tableStore.autoFootHeight) ? {
        height: pxToRem(get(tableStore.lockColumnsFootRowsHeight, 0)),
    } : undefined;
    const tr = (React.createElement("tr", { style: style }, getTds()));
    const classString = classNames(`${prefixCls}-tfoot`, {
        [`${prefixCls}-tfoot-bordered`]: overflowX,
    });
    return (React.createElement("tfoot", { className: classString }, !isStickySupport() && !lock && (rowHeight === 'auto' || tableStore.autoFootHeight) ? (React.createElement(ResizeObservedRow, { onResize: handleResize, rowIndex: 0 }, tr)) : tr));
});
TableFooter.displayName = 'TableFooter';
export default TableFooter;
